<template>
  <VirtualList
    class="virtual-list"
    :data-key="'id'"
    :data-sources="list"
    :data-component="dataComponent"
    @tobottom="getData"
    style="height: 100%; overflow-y: auto"
  >
    <div slot="footer" class="loading-wrapper">
      <div v-if="finished">没有更多啦</div>
      <Loading size="24px" v-else>加载中...</Loading>
    </div>
  </VirtualList>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list'
import { Loading } from 'vant'
export default {
  components: { VirtualList, Loading },
  props: {
    dataComponent: {
      type: [Object, Function],
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
    finished: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.finished === false) {
        this.$emit('getData')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.loading-wrapper {
  padding: 20px 0 70px;
  font-size: 28px;
  color: #888;
  text-align: center;
}
</style>